<div #rootWrapper (click)="clickInsidePage($event, rootWrapper)">
  <nav class="navbar signnow-color navbar-fixed-top" *ngIf="hideBar === false">
    <div class="navbar-container">
      <div class="navbar-header">
        <img class="g-logo" src="./../assets/images/signnow-logo-white.svg" />
      </div>
    </div>
  </nav>
  <div [attr.class]="view === 'status' ? 'status-container' : 'container'">
    <div class="starter-template">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
